import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as Highcharts from 'src/assets/js/highcharts';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { Router } from '@angular/router';
import { MapService } from 'src/app/Services/map.service';
import { CommonServices } from 'src/app/Services/common.service';

declare const ApexCharts: any;
declare const Chart: any;
declare var google: any;

declare const am4charts: any, am4core: any, am4themes_animated: any;

@Component({
  selector: 'g10-roster-summary',
  templateUrl: './roster-summary.component.html',
  styleUrls: ['./roster-summary.component.css']
})
export class RosterSummaryComponent implements OnInit {


  public filterForm: FormGroup;
  public todayDate: any = new Date();
  public countDatas: any = '';
  public shiftListArr: any = [];
  public pickupShiftArr: any = [];
  public dropShiftArr: any = [];
  public tripCntObj: any = {};
  public tripCntFinalObj: any = {};

  // Vehicle Data Variables
  public vehHeaders: any = ['#', 'Reg no', 'Drive name', 'Shift time', 'Route name'];
  public vehDetails: any = []
  //  public noDataFound:string='';

  // Map Variables
  public selectedMap: string = 'google';
  public googleMapObj: any;
  public primaryMap: any;
  public rosterMapHeight: string = '68vh';
  public searchedValue: any = '';
  public serchKey = 'vehRegNo';
  // DialogBoxVariables
  public dialogHeaders: any = ['#', 'Emp ID', 'Name', 'Gender', 'ETA', 'Attendance time', 'Address'];
  public dialogSampleData: any = [];

  //No data
  public isPickupAvail:boolean=false;
  public isDropAvail:boolean=false;

  constructor(
    public api: ApiService,
    public router: Router,
    public storage: StorageService,
    public mapService: MapService,
    public com: CommonServices
  ) {
    this.filterFormLoad();
    this.rosterSummaryAPI({
      tripDate: new Date(new Date(this.filterForm.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
      // transitMode: this.filterForm.value.transitMode
    });
    let user = this.storage.get('userInfo');

  }

  ngOnInit(): void {
    this.initialingMap();
  }

  // Form load
  filterFormLoad() {
    this.filterForm = new FormGroup({
      tripDate: new FormControl(this.todayDate),
      // transitMode: new FormControl(''),
      // empCnt: new FormControl(''),
    })
  }

  rosterSummaryAPI(obj: any) {
    this.api.transportManagerRosterSummary(obj).then((res: any) => {
      if (res && res['status'] && res['status'] == 'Success') {
        this.countDatas = res['data']
        this.getTotalCounts(res['data']);
        this.allShiftWiseChart(res['data']);
        this.shiftWiseStatusChart(res['data']);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  // Make the Object in Our Wise 
  public tripModeWise: any = {
    total: [],
    intransit: [],
    yetToStart: [],
    completed: []
  };
  public pickupLabelArr: any = [];
  public dropLabelArr: any = [];
  public empInfoArr: any = []

  getTotalCounts(item: any) {
    let totalArr=[];
    let intransArr=[];
    let yetTostartArr=[];
    let completedArr=[];
    if (item && item != '') {
      let transitModes = Object.keys(item)
      for (let i = 0; i < transitModes.length; i++) {
        let valsOfTransitmodes = Object.keys(item[transitModes[i]])
        for (let j = 0; j < valsOfTransitmodes.length; j++) {
          let transValues = Object.keys(item[transitModes[i]][valsOfTransitmodes[j]]);
          if (transValues && transValues.length > 0) {
            // Trip Count Obj
            let finalObj = {
              completed: 0,
              intransit: 0,
              yetToStart: 0,
            };
            // Drop Employee Obj
            let dropEmpObj = {
              dropSafeDropEmpCnt: 0,
              dropNoShwEmpCnt: 0,
              dropMaleCnt: 0,
              dropFMaleCnt: 0,
              dropTtlEmps: 0,
            };
            // Pickup Employee Obj
            let pickupEmpbj = {
              pickupBoardEmpCnt: 0,
              pickupNoShwEmpCnt: 0,
              pickupTripCnt: 0,
              pickupMaleCnt: 0,
              pickupFMaleCnt: 0,
              pickupTtlEmps: 0,
            };

            for (let k = 0; k < transValues.length; k++) {
              this.tripCntObj = item[transitModes[i]][valsOfTransitmodes[j]][transValues[k]];
              //Get Total Trip Count && Employee Count
              if (transitModes[i] && transitModes[i] == 'Pickup') {
                // Trip
                finalObj['completed'] += this.tripCntObj.trip['completed'].length>0 ? Number(this.tripCntObj.trip['completed'].length):0;
                finalObj['intransit'] += this.tripCntObj.trip['intransit'].length>0 ? Number(this.tripCntObj.trip['intransit'].length):0;
                finalObj['yetToStart'] += this.tripCntObj.trip['yetToStart'].length>0 ? Number(this.tripCntObj.trip['yetToStart'].length):0;
                // Emp Trip Details
                pickupEmpbj['pickupBoardEmpCnt'] += this.tripCntObj.emp['boarded']?this.tripCntObj.emp['boarded']:0;
                pickupEmpbj['pickupNoShwEmpCnt'] += this.tripCntObj.emp['noShow']?this.tripCntObj.emp['noShow']:0;
                pickupEmpbj['pickupTtlEmps'] += (this.tripCntObj.emp['boarded'] + this.tripCntObj.emp['noShow']);


                pickupEmpbj['pickupMaleCnt'] += this.tripCntObj.emp['male'];
                pickupEmpbj['pickupFMaleCnt'] += this.tripCntObj.emp['female'];

                pickupEmpbj['pickupTripCnt'] += ((this.tripCntObj.trip['completed'].length>0?Number(this.tripCntObj.trip['completed'].length):0) +
                (this.tripCntObj.trip['intransit'].length>0?Number(this.tripCntObj.trip['intransit'].length):0) + (this.tripCntObj.trip['yetToStart'].length>0?Number(this.tripCntObj.trip['yetToStart'].length):0));

                this.tripCntFinalObj['pickupCntDtls'] = pickupEmpbj;
                // Trip
                this.tripCntFinalObj['Pickup'] = finalObj;
                // Get All Driver Details
                let getTripCnts = Object.keys(this.tripCntObj.trip);
                for (let d = 0; d < getTripCnts.length; d++) {
                  let driverDtls = this.tripCntObj.trip[getTripCnts[d]];
                  if (driverDtls && driverDtls.length > 0) {
                    for (let s = 0; s < driverDtls.length; s++) {
                      totalArr.push(driverDtls[s]) // All Driver Details
                    }

                    let yetToStr = this.tripCntObj.trip['yetToStart'];
                    let intransitToStr = this.tripCntObj.trip['intransit'];
                    let completeStr = this.tripCntObj.trip['completed'];
                    if (getTripCnts[d]=='yetToStart' && yetToStr && yetToStr.length > 0 && yetToStr != undefined)
                      yetTostartArr = [...yetTostartArr, ...yetToStr];
                    if (getTripCnts[d]=='intransit' && intransitToStr && intransitToStr.length > 0 && intransitToStr != undefined)
                      intransArr = [...intransArr, ...intransitToStr];
                    if (getTripCnts[d]=='completed' && completeStr && completeStr.length > 0 && completeStr != undefined)
                      completedArr = [...completedArr, ...completeStr];
                  }
                }
                this.pickupLabelArr = Object.keys(item[transitModes[i]]['shiftData']);
              }

              if (transitModes[i] == 'Drop') {
                // Trip
                finalObj['completed'] += this.tripCntObj.trip['completed'].length>0?Number(this.tripCntObj.trip['completed'].length):0;
                finalObj['intransit'] += this.tripCntObj.trip['intransit'].length>0?Number(this.tripCntObj.trip['intransit'].length):0;
                finalObj['yetToStart'] += this.tripCntObj.trip['yetToStart'].length>0?Number(this.tripCntObj.trip['yetToStart'].length):0;
                // Emp
                dropEmpObj['dropSafeDropEmpCnt'] += this.tripCntObj.emp['safeDrop']?this.tripCntObj.emp['safeDrop']:0;
                dropEmpObj['dropNoShwEmpCnt'] += this.tripCntObj.emp['noShow']?this.tripCntObj.emp['noShow']:0;
                dropEmpObj['dropTtlEmps'] += this.tripCntObj.emp['safeDrop'] + this.tripCntObj.emp['noShow'];
                dropEmpObj['dropTripCnt'] += ((this.tripCntObj.trip['completed'].length>0?Number(this.tripCntObj.trip['completed'].length):0) +
                  (this.tripCntObj.trip['intransit'].length>0?Number(this.tripCntObj.trip['intransit'].length):0) + (this.tripCntObj.trip['yetToStart'].length>0?Number(this.tripCntObj.trip['yetToStart'].length):0));
                dropEmpObj['dropMaleCnt'] += this.tripCntObj.emp['male'];
                dropEmpObj['dropFMaleCnt'] += this.tripCntObj.emp['female'];

                this.tripCntFinalObj['dropCntDtls'] = dropEmpObj;
                // Trip
                this.tripCntFinalObj['Drop'] = finalObj;
                // Get All Driver Details
                let getTripCnts = Object.keys(this.tripCntObj.trip);
                for (let d = 0; d < getTripCnts.length; d++) {
                  let driverDtls = this.tripCntObj.trip[getTripCnts[d]]
                  if (driverDtls && driverDtls.length > 0) {
                    for (let s = 0; s < driverDtls.length; s++) {
                      totalArr.push(driverDtls[s])
                    }
                    let yetToStr = this.tripCntObj.trip['yetToStart'];
                    let intransitToStr = this.tripCntObj.trip['intransit'];
                    let completeStr = this.tripCntObj.trip['completed'];

                    if (getTripCnts[d]=='yetToStart' && yetToStr && yetToStr.length > 0 && yetToStr != undefined)
                      yetTostartArr = [...yetTostartArr, ...yetToStr];
                    if (getTripCnts[d]=='intransit' && intransitToStr && intransitToStr.length > 0 && intransitToStr != undefined)
                      intransArr = [...intransArr, ...intransitToStr];
                    if (getTripCnts[d]=='completed' && completeStr && completeStr.length > 0 && completeStr != undefined)
                      completedArr = [...completedArr, ...completeStr];
                  }
                }
                this.dropLabelArr = Object.keys(item[transitModes[i]]['shiftData']);
              }
            }
          }
        }
      }
    }
    this.tripModeWise['total']=this.reqOrderByShiftTime(totalArr);
    this.tripModeWise['intransit']=this.reqOrderByShiftTime(intransArr);
    this.tripModeWise['yetToStart']=this.reqOrderByShiftTime(yetTostartArr);
    this.tripModeWise['completed']=this.reqOrderByShiftTime(completedArr);
    if(this.tripCntFinalObj && this.tripCntFinalObj['Pickup'] && (this.tripCntFinalObj['Pickup']['completed']!=0 || this.tripCntFinalObj['Pickup']['intransit']!=0 || this.tripCntFinalObj['Pickup']['yetToStart']!=0)){
      this.isPickupAvail=true;
    }else{
      this.isPickupAvail=false;
    }
    if(this.tripCntFinalObj && this.tripCntFinalObj['Drop'] && (this.tripCntFinalObj['Drop']['completed']!=0 || this.tripCntFinalObj['Drop']['intransit']!=0 || this.tripCntFinalObj['Drop']['yetToStart']!=0)){
      this.isDropAvail=true;
    }else{
      this.isDropAvail=false;
    }
    setTimeout(() => {
      this.employeeChartRendering(this.tripCntFinalObj);
      this.pickupDropStatusChart(this.tripCntFinalObj);
    }, 100);
  }
  
  employeeChartRendering(Obj: any) {
    if (this.isPickupAvail) {
      this.isPickupAvail=true;
      var ctx = document.getElementById('myChart');
      var myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Completed', 'Intransit', 'Yet to start',],
          datasets: [{
            data: [(Obj&&Obj.Pickup&&Obj.Pickup.completed) ? Obj.Pickup.completed : 0, (Obj&& Obj.Pickup&&Obj.Pickup.intransit) ? Obj.Pickup.intransit:0, (Obj&& Obj.Pickup&&Obj.Pickup.yetToStart) ? Obj.Pickup.yetToStart:0],
            backgroundColor: ['rgba(76, 175, 80,0.4)', 'rgba(98,100,167,0.4)', 'rgba(68,136,209,0.4)'],
            borderColor: ['rgba(76, 175, 80,0.4)', 'rgba(98,100,167,0.4)', 'rgba(68,136,209,0.4)'],
            hoverBackgroundColor: ['rgb(76, 175, 80)', 'rgb(98,100,167)', 'rgb(68,136,209)'],
            borderWidth: 1,
          }]
        },
        options: {
          plugins: {
            datalabels: {
              display: true,
              align: 'center',
              anchor: 'center',
              formatter: function (value, index, values) {
                if (value > 0) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(',');
                  return value;
                } else {
                  value = "";
                  return value;
                }
              }
            }
          },
          title: {
            display: true,
            text: 'Pickup'
          },
          tooltips: {
            mode: 'dataset'
          },
          cutoutPercentage: 60,
          hoverOffset: 4,
          legend: {
            // display: true,
            position: 'bottom',
            labels: {
              boxWidth: 10
            }
          },
        },
      });
    }

    if (this.isDropAvail) {
      this.isDropAvail=true;
      var dropCtx = document.getElementById('dropChart');
      var myCharts = new Chart(dropCtx, {
        type: 'doughnut',
        data: {
          color: '#232323',
          labels: ['Completed', 'Intransit', 'Yet to start'],
          datasets: [{
            data: [((Obj&&Obj.Drop&&Obj.Drop.completed) ? Obj&&Obj.Drop&&Obj.Drop.completed :0), ((Obj&&Obj.Drop&&Obj.Drop.intransit) ? Obj&&Obj.Drop&&Obj.Drop.intransit:0), ((Obj&&Obj.Drop&&Obj.Drop.yetToStart) ? Obj&&Obj.Drop&&Obj.Drop.yetToStart:0)],
            // data: [11, 34, 22],
            backgroundColor: ['rgba(76, 175, 80,0.4)', 'rgba(98,100,167,0.4)', 'rgba(68,136,209,0.4)'],
            borderColor: ['rgba(76, 175, 80,0.4)', 'rgba(98,100,167,0.4)', 'rgba(68,136,209,0.4)'],
            hoverBackgroundColor: ['rgb(76, 175, 80)', 'rgb(98,100,167)', 'rgb(68,136,209)'],
            borderWidth: 1,
          }]
        },
        options: {
          plugins: {
            datalabels: {
              display: true,
              align: 'center',
              anchor: 'center',
              formatter: function (value, index, values) {
                if (value > 0) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(',');
                  return value;
                } else {
                  value = "";
                  return value;
                }
              }
            }
          },
          title: {
            display: true,
            text: 'Drop'
          },
          tooltips: {
            mode: 'dataset',
          },
          cutoutPercentage: 60,
          hoverOffset: 4,
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 10
            },
          },
        },
      });
    }
  }

  pickupDropStatusChart(Obj: any) {
    var pickupEMPCnt = document.getElementById('totalAttendanceChart');
    // var total = Obj.pickupCntDtls.pickupBoardEmpCnt + Obj.pickupCntDtls.pickupNoShwEmpCnt
    var myChart = new Chart(pickupEMPCnt, {
      type: 'bar',
      data: {
        labels: ['Pickup', 'Drop'],
        datasets: [{
          label: 'Boarded / Safe Drop',
          // data:[],
          data: [(Obj.pickupCntDtls && Obj.pickupCntDtls.pickupBoardEmpCnt) ? Obj.pickupCntDtls.pickupBoardEmpCnt : 0, Obj.dropCntDtls&&Obj.dropCntDtls.dropSafeDropEmpCnt? Obj.dropCntDtls.dropSafeDropEmpCnt:0],
          backgroundColor: ['rgba(211,235,251,0.7)', 'rgba(211,235,251,0.7)',],
          borderColor: ['rgb(202,178,255)', 'rgb(202,178,255)'],
          hoverBackgroundColor: ['rgb(211,235,251)', 'rgb(211,235,251)'],
          barThickness: 40,
          borderWidth: 1,
        }, {
          label: 'No Show',
          data: [(Obj.pickupCntDtls && Obj.pickupCntDtls.pickupNoShwEmpCnt) ? Obj.pickupCntDtls.pickupNoShwEmpCnt : 0, (Obj.dropCntDtls&&Obj.dropCntDtls.dropNoShwEmpCnt? Obj.dropCntDtls.dropNoShwEmpCnt:0)],
          backgroundColor: ['rgba(249,222,229,0.7)', 'rgba(249,222,229,0.7)',],
          borderColor: ['rgb(236,138,164)', 'rgb(236,138,164)'],
          hoverBackgroundColor: ['rgb(249,222,229)', 'rgb(249,222,229)'],
          barThickness: 40,
          borderWidth: 1,
        }]
      },
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            formatter: function (value, index, values) {
              if (value > 0) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(',');
                return value;
              } else {
                value = "";
                return value;
              }
            }
          }
        },
        responsive: true,
        tooltips: {
          mode: 'point'
        },
        cutoutPercentage: 60,
        hoverOffset: 4,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          },
        },
        scales: {
          xAxes: [{
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- Transit Mode --'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              },
            },
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- # Employee --'
            }
          }],
        },
      }

    });

    // Drop Area implement
    var dropEMPCnt = document.getElementById('employeeGenderCntChart');
    // var total = Obj.dropCntDtls.dropSafeDropEmpCnt + Obj.dropCntDtls.dropNoShwEmpCnt;
    var myChart = new Chart(dropEMPCnt, {
      type: 'bar',
      data: {
        labels: ['Pickup', 'Drop'],
        datasets: [{
          label: 'Male',
          data: [Obj.pickupCntDtls&&Obj.pickupCntDtls.pickupMaleCnt?Obj.pickupCntDtls.pickupMaleCnt:0, Obj.dropCntDtls&&Obj.dropCntDtls.dropMaleCnt?Obj.dropCntDtls.dropMaleCnt:0],
          backgroundColor: ['rgba(211,235,251,0.7)', 'rgba(211,235,251,0.7)',],
          hoverBackgroundColor: ['rgb(211,235,251)', 'rgb(211,235,251)'],
          borderColor: ['rgb(202,178,255)', 'rgb(202,178,255)'],
          borderWidth: 1,
          barThickness: 40
        }, {
          label: 'Female',
          data: [Obj.pickupCntDtls&&Obj.pickupCntDtls.pickupFMaleCnt?Obj.pickupCntDtls.pickupFMaleCnt:0, Obj.dropCntDtls&&Obj.dropCntDtls.dropFMaleCnt?Obj.dropCntDtls.dropFMaleCnt:0],
          backgroundColor: ['rgba(249,222,229,0.7)', 'rgba(249,222,229,0.7)'],
          hoverBackgroundColor: ['rgb(249,222,229)', 'rgb(249,222,229)'],
          borderColor: ['rgb(236,138,164)', 'rgb(236,138,164)'],
          borderWidth: 1,
          barThickness: 40
        }]
      },
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            formatter: function (value, index, values) {
              if (value > 0) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(',');
                return value;
              } else {
                value = "";
                return value;
              }
            }
          }
        },
        responsive: true,
        tooltips: {
          mode: 'point'
        },
        cutoutPercentage: 60,
        // hoverOffset: 4,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          },
        },
        scales: {
          xAxes: [{
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- Transit Mode --'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              },
            },
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- # Employee --'
            }
          }],
        },
      }
    });

  }

  sideBarNavigation(path: any) {
    this.router.navigateByUrl(`/organization/transport-manager/${path}`);
  }


  // Attendance Chart (Shift Wise)
  allShiftWiseChart(Obj: any) {
    let shiftData: any = '';
    let pickupCountsObj: object = {
      maleCnt: [],
      femaleCnt: [],
      pickupLabels: [],
    }
    let dropCountsObj: object = {
      maleCnt: [],
      femaleCnt: [],
      dropLabels: [],
    }
    let pickupLabels = [];
    if (Obj && Obj != '') {
      let transitModes = Object.keys(Obj)
      for (let i = 0; i < transitModes.length; i++) {
        shiftData = Obj[transitModes[i]]['shiftData']; //{16:55: {…}, 16:40: {…}, 11:14: {…}}
        if (transitModes[i] == 'Pickup') {
          let getPickupShift = this.sortByShift(Object.keys(shiftData));
          for (let i = 0; i < getPickupShift.length; i++) {
            if (pickupCountsObj['pickupLabels']) pickupCountsObj['pickupLabels'].push(getPickupShift[i]);
            let empVals = shiftData[getPickupShift[i]]['emp'];
            let male = 0;
            let female = 0;
            if (empVals && empVals['male'] && empVals['male'] != '') male = empVals['male'];
            if (empVals && empVals['female'] && empVals['female'] != '') female = empVals['female'];
            pickupCountsObj['maleCnt'].push(male);
            pickupCountsObj['femaleCnt'].push(female);
          }
        }
        if (transitModes[i] == 'Drop') {
          let getDropShift = this.sortByShift(Object.keys(shiftData));
          for (let j = 0; j < getDropShift.length; j++) {
            if (dropCountsObj['dropLabels']) dropCountsObj['dropLabels'].push(getDropShift[j]);
            let empVals = shiftData[getDropShift[j]]['emp'];
            let male = 0;
            let female = 0;
            if (empVals && empVals['male'] && empVals['male'] != '') male = empVals['male'];
            if (empVals && empVals['female'] && empVals['female'] != '') female = empVals['female'];
            dropCountsObj['maleCnt'].push(male);
            dropCountsObj['femaleCnt'].push(female);
          }
        }
      }
    }

    var pickupChart = document.getElementById('allShiftPickupChart');
    var myChart = new Chart(pickupChart, {
      type: 'bar',
      data: {
        labels: pickupCountsObj['pickupLabels'],
        datasets: [
          {
            label: 'Male',
            data: pickupCountsObj['maleCnt'],
            backgroundColor: pickupCountsObj['maleCnt'].map((e) => { return 'rgba(211,235,251,0.7)' }),
            borderColor: pickupCountsObj['maleCnt'].map((e) => { return 'rgb(202,178,255)' }),
            hoverBackgroundColor: pickupCountsObj['maleCnt'].map((e) => { return "rgb(211,235,251)" }),
            barThickness: 40,
            borderWidth: 1,
          },
          {
            label: 'Female',
            data: pickupCountsObj['femaleCnt'],
            backgroundColor: pickupCountsObj['femaleCnt'].map((e) => { return 'rgba(249,222,229,0.7)' }),
            borderColor: pickupCountsObj['femaleCnt'].map((e) => { return 'rgb(234,116,152)' }),
            hoverBackgroundColor: pickupCountsObj['femaleCnt'].map((e) => { return 'rgb(249,222,229)' }),
            barThickness: 40,
            borderWidth: 1,
          }
        ]
      },
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            formatter: function (value, index, values) {
              if (value > 0) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(',');
                return value;
              } else {
                value = "";
                return value;
              }
            }
          }
        },
        responsive: true,
        tooltips: {
          mode: 'point'
        },
        cutoutPercentage: 60,
        hoverOffset: 4,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          },
        },
        scales: {
          xAxes: [{
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- Shift Time --'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              },
            },
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- # Employee --'
            }
          }],
        },
      }
    });
    var dropChartRender = document.getElementById('allShiftDropChart');
    var myChart = new Chart(dropChartRender, {
      type: 'bar',
      data: {
        labels: dropCountsObj['dropLabels'],
        datasets: [{
          label: 'Male',
          data: dropCountsObj['maleCnt'],
          backgroundColor: dropCountsObj['maleCnt'].map((e) => { return 'rgba(211,235,251,0.7)' }),
          borderColor: dropCountsObj['maleCnt'].map((e) => { return 'rgb(202,178,255)' }),
          hoverBackgroundColor: dropCountsObj['maleCnt'].map((e) => { return "rgb(211,235,251)" }),
          barThickness: 40,
          borderWidth: 1,
        },
        {
          label: 'Female',
          data: dropCountsObj['femaleCnt'],
          backgroundColor: dropCountsObj['femaleCnt'].map((e) => { return 'rgba(249,222,229,0.7)' }),
          borderColor: dropCountsObj['femaleCnt'].map((e) => { return 'rgb(234,116,152)' }),
          hoverBackgroundColor: dropCountsObj['femaleCnt'].map((e) => { return 'rgb(249,222,229)' }),
          barThickness: 40,
          borderWidth: 1,
        },
        ]
      },
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            formatter: function (value, index, values) {
              if (value > 0) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(',');
                return value;
              } else {
                value = "";
                return value;
              }
            }
          }
        },
        responsive: true,
        tooltips: {
          mode: 'point'
        },
        cutoutPercentage: 60,
        hoverOffset: 4,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          },
        },
        scales: {
          xAxes: [{
            stacked: true, // this should be set to make the bars stacked
            scaleLabel: {
              display: true,
              labelString: '-- Shift Time --'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              },
            },
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- # Employee --'
            }
          }],
        }
      }
    });

  }
  sortByShift(data)
  {
      let newArr = data.sort(
      (p1, p2) => (p1 > p2) ? 1 : (p1 < p2) ? -1 : 0);
     return newArr;
  }
  // Every shiftwise boared status
  shiftWiseStatusChart(Obj: any) {
    let shiftData: any = '';
    let pickupCountsObj: object = {
      bordedCnt: [],
      noShowCnt: [],
      pickupLabels: [],
    }
    let dropCountsObj: object = {
      safeDrop: [],
      noShowCnt: [],
      dropLabels: [],
    }
    if (Obj && Obj != '') {
      let transitModes = Object.keys(Obj)
      for (let i = 0; i < transitModes.length; i++) {
        shiftData = Obj[transitModes[i]]['shiftData']; //{16:55: {…}, 16:40: {…}, 11:14: {…}}
        if (transitModes[i] == 'Pickup') {
          let getPickupShift = this.sortByShift(Object.keys(shiftData));
          for (let i = 0; i < getPickupShift.length; i++) {
            if (pickupCountsObj['pickupLabels']) pickupCountsObj['pickupLabels'].push(getPickupShift[i]);
            let empVals = shiftData[getPickupShift[i]]['emp'];
            let boarded = 0;
            let noShow = 0;
            if (empVals && empVals['boarded'] && empVals['boarded'] != '') boarded = empVals['boarded'];
            if (empVals && empVals['noShow'] && empVals['noShow'] != '') noShow = empVals['noShow'];
            pickupCountsObj['bordedCnt'].push(boarded);
            pickupCountsObj['noShowCnt'].push(noShow);
          }
        }
        if (transitModes[i] == 'Drop') {
          let getDropShift = this.sortByShift(Object.keys(shiftData));
          for (let d = 0; d < getDropShift.length; d++) {
            if (dropCountsObj['dropLabels']) dropCountsObj['dropLabels'].push(getDropShift[d]);
            let empVals = shiftData[getDropShift[d]]['emp'];
            let safeDrop = 0;
            let noShow = 0;
            if (empVals && empVals['safeDrop'] && empVals['safeDrop'] != '') safeDrop = empVals['safeDrop'];
            if (empVals && empVals['noShow'] && empVals['noShow'] != '') noShow = empVals['noShow'];
            dropCountsObj['safeDrop'].push(safeDrop);
            dropCountsObj['noShowCnt'].push(noShow);
          }
        }
      }
    }


    // Pickup Status Chart
    var dsropCtx = document.getElementById('allShiftPickupStatusChart');
    let total = pickupCountsObj['bordedCnt'].length + pickupCountsObj['noShowCnt'].length
    var myChart = new Chart(dsropCtx, {
      type: 'bar',
      data: {
        labels: pickupCountsObj['pickupLabels'],
        datasets: [{
          label: 'Boarded',
          data: pickupCountsObj['bordedCnt'],
          backgroundColor: pickupCountsObj['bordedCnt'].map((e) => { return 'rgba(211,235,251,0.7)' }),
          borderColor: pickupCountsObj['bordedCnt'].map((e) => { return 'rgb(202,178,255)' }),
          hoverBackgroundColor: pickupCountsObj['bordedCnt'].map((e) => { return "rgb(211,235,251)" }),
          barThickness: 40,
          borderWidth: 1,
        },
        {
          label: 'No Show',
          data: pickupCountsObj['noShowCnt'],
          backgroundColor: pickupCountsObj['noShowCnt'].map((e) => { return 'rgba(249,222,229,0.7)' }),
          borderColor: pickupCountsObj['noShowCnt'].map((e) => { return 'rgb(234,116,152)' }),
          hoverBackgroundColor: pickupCountsObj['noShowCnt'].map((e) => { return 'rgb(249,222,229)' }),
          barThickness: 40,
          borderWidth: 1,
        }
        ]
      },
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            formatter: function (value, index, values) {
              if (value > 0) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(',');
                return value;
              } else {
                value = "";
                return value;
              }
            }
          }
        },
        responsive: true,
        tooltips: {
          mode: 'point'
        },
        cutoutPercentage: 60,
        hoverOffset: 4,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          },
        },
        scales: {
          xAxes: [{
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- Shift Time --'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              },
            },
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- # Employee --'
            }
          }],
        },
      }
    });

    // Drop Status Chart
    var dropChartRender = document.getElementById('allShiftDropStatusChart');
    var myChart = new Chart(dropChartRender, {
      type: 'bar',
      data: {
        labels: dropCountsObj['dropLabels'],
        datasets: [{
          label: 'Safe Drop',
          data: dropCountsObj['safeDrop'],
          backgroundColor: dropCountsObj['safeDrop'].map((e) => { return 'rgba(211,235,251,0.7)' }),
          borderColor: dropCountsObj['safeDrop'].map((e) => { return 'rgb(202,178,255)' }),
          hoverBackgroundColor: dropCountsObj['safeDrop'].map((e) => { return "rgb(211,235,251)" }),
          barThickness: 40,
          borderWidth: 1,
        },
        {
          label: 'No Show',
          data: dropCountsObj['noShowCnt'],
          backgroundColor: dropCountsObj['noShowCnt'].map((e) => { return 'rgba(249,222,229,0.7)' }),
          borderColor: dropCountsObj['noShowCnt'].map((e) => { return 'rgb(234,116,152)' }),
          hoverBackgroundColor: dropCountsObj['noShowCnt'].map((e) => { return 'rgb(249,222,229)' }),
          barThickness: 40,
          borderWidth: 1,
        },

        ]
      },
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            formatter: function (value, index, values) {
              if (value > 0) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(',');
                return value;
              } else {
                value = "";
                return value;
              }
            }
          }
        },
        responsive: true,
        tooltips: {
          mode: 'point'
        },
        cutoutPercentage: 60,
        hoverOffset: 4,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          },
        },
        scales: {
          xAxes: [{
            stacked: true ,// this also..
            scaleLabel: {
              display: true,
              labelString: '-- Shift Time --'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              },
            },
            stacked: true, // this also..
            scaleLabel: {
              display: true,
              labelString: '-- # Employee --'
            }
          }],
        },
      }
    });
  }

  // Show the employees details Dialog Box 
  public showBox: Boolean = false;
  public vehDtlsObj: any = {};
  public isShowTableSearch = false;
  public bothTripCnt: object = {
    pickup: {
      boarded: 0,
      noShow: 0,
    },
    drop: {
      safeDrop: 0,
      noShow: 0,
    }
  }

  public tripStsObj: Object = {
    inTransit: true,
    yetToStart: false,
    completed: false,
    total:false,
  }
  reqOrderByETA(data)
  {
      let newArr = data.sort(
      (p1, p2) => (p1.etaStr > p2.etaStr) ? 1 : (p1.etaStr < p2.etaStr) ? -1 : 0);
     return newArr;
  }
  reqOrderByShiftTime(data)
  {
      let newArr = data.sort(
      (p1, p2) => (p1.shiftTimeStr > p2.shiftTimeStr) ? 1 : (p1.shiftTimeStr < p2.shiftTimeStr) ? -1 : 0);
     return newArr;
  }
  crtlDialogueBox(key: any, vehDetails: any, tripMod: any) {
    if (key && key == 'Open') {
      if (tripMod == 'intran') {
        this.tripStsObj['inTransit'] = true;
        this.tripStsObj['yetToStart'] = false;
        this.tripStsObj['completed'] = false;
        this.tripStsObj['total'] = false;
      }
      if (tripMod == 'completed') {
        this.tripStsObj['inTransit'] = false;
        this.tripStsObj['yetToStart'] = false;
        this.tripStsObj['completed'] = true;
        this.tripStsObj['total'] = false;
      }
      if (tripMod == 'yetTo') {
        this.tripStsObj['inTransit'] = false;
        this.tripStsObj['yetToStart'] = true;
        this.tripStsObj['completed'] = false;
        this.tripStsObj['total'] = false;
      }
      if (tripMod == 'total') {
        this.tripStsObj['inTransit'] = false;
        this.tripStsObj['yetToStart'] = false;
        this.tripStsObj['completed'] = false;
        this.tripStsObj['total'] = true;
      }
      this.bothTripCnt = {
        pickup: {
          boarded: 0,
          noShow: 0,
        },
        drop: {
          safeDrop: 0,
          noShow: 0,
        }
      }
      this.showBox = true;
      this.vehDtlsObj = vehDetails;
      this.vehDtlsObj['empInfo']=this.reqOrderByETA(vehDetails['empInfo']);
      this.empInfoArr = vehDetails['empInfo'];
      if (vehDetails && vehDetails['transitMode'] == 'Pickup') {
        for (let a = 0; a < this.empInfoArr.length; a++) {
          if (this.empInfoArr && this.empInfoArr[a]['attenTime'] && this.empInfoArr[a]['attenTime'] != '') {
            this.bothTripCnt['pickup']['boarded']++;
          }
          if (this.empInfoArr && this.empInfoArr[a] && this.empInfoArr[a]['attenTime'] === undefined) {
            this.bothTripCnt['pickup']['noShow']++;
          }
        }
      }
      if (vehDetails && vehDetails['transitMode'] == 'Drop') {
        for (let a = 0; a < this.empInfoArr.length; a++) {
          if (this.empInfoArr && this.empInfoArr[a]['attenTime'] && this.empInfoArr[a]['attenTime'] != '') {
            this.bothTripCnt['drop']['safeDrop']++;
          }
          if (this.empInfoArr && this.empInfoArr[a] && this.empInfoArr[a]['attenTime'] === undefined) {
            this.bothTripCnt['drop']['noShow']++;
          }
        }
      }

    }
    if (key && key == 'Close') {
      this.showBox = false;
      this.vehDtlsObj = {};
    }
  }
  // Map Area
  initialingMap() {
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        const mapOptions = {
          scrollwheel: true,
          zoom: 10,
          maxZoom: 17,
          center: new google.maps.LatLng(13.1031, 80.1794),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('rosterSummaryMap'), mapOptions);
      }, 100)
    }
  }

}

